import { createHttpLink, ApolloClient, InMemoryCache } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import useGlobalUrl from './useGlobalUrl';
import { setContext } from '@apollo/client/link/context';
import useServerCrash from './useServerCrash';
import useSilentAccessToken from './useSilentAccessToken';
import { auth0 } from '@/composables/useAuth0Client';

const cache = new InMemoryCache();
const { graphqlUrl } = useGlobalUrl();
const { serverHasCrashed } = useServerCrash();
const httpLink = createHttpLink({
  uri: graphqlUrl,
});

// maybe 503 or any 500 before init load???

// Error link to handle 401 unauthorized errors
const errorLink = onError(({ graphQLErrors, networkError }) => {
  const { loginWithRedirect } = auth0;

  if (networkError && networkError.statusCode === 401) {
    console.log('401 Unauthorized - redirecting to login');
    console.log('not authenticated - apollo');
    loginWithRedirect();
    return;
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      if (extensions && extensions.code === 'UNAUTHENTICATED') {
        console.log('GraphQL Authentication Error - redirecting to login');
        console.log('not authenticated - apollo');
        loginWithRedirect();
        return;
      }
    });
  }

  if (networkError) {
    serverHasCrashed.value = true;
    return;
  }
});

const authLink = setContext(async (_, { headers }) => {
  const { getAccessToken } = useSilentAccessToken();
  const token = await getAccessToken();

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const apolloClient = new ApolloClient({
  cache,
  link: errorLink.concat(authLink.concat(httpLink)),
});

export default apolloClient;
